/**
 * Created by jonas on 2021-10-22.
 */
import {gsap} from "gsap";
import {TrueGrit} from "../TrueGrit";
import {TrueGritGameAssets} from "../TrueGritGameAssets";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {TrueGritSymbol} from "./TrueGritSymbol";


export function isTrueGritTransformSymbol(value:any):value is TrueGritSymbolTransformAnimation {
    return value.symbolName === "T" || value.symbolName === "T2";
}


export interface TransformSymbolPart {
    view:PIXI.Container,
    background:PIXI.Sprite,
    frame:PIXI.Sprite,
    character:PIXI.Sprite,
    characterTint:PIXI.Sprite,
}


export class TrueGritSymbolTransformAnimation extends PIXI.Container {
    private static WIN_SHINE_OFFSET:PIXI.Point = new PIXI.Point(71, 70);

    private _isLowSymbol:boolean = false;
    private graphicsContainer:PIXI.Container;
    private goldSymbol:PIXI.Sprite;
    private blackSymbol:PIXI.Sprite;
    private _attentionAnimation:TimelineSprite;

    constructor(isLow:boolean, transformToSymbol:string, splits:number = 1) {
        super();
        this._isLowSymbol = isLow;
        this.graphicsContainer = new PIXI.Container();

        let splitLevelString = "";
        if(splits > 1) {
            splitLevelString = "_split_0" + splits;
        }
        this.goldSymbol = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.getSymbolStateTexturePath(transformToSymbol, splitLevelString + "_gold"))[0]);
        this.blackSymbol = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.getSymbolStateTexturePath(transformToSymbol, splitLevelString + "_gold_black"))[0]);
        this.goldSymbol.alpha = 0;
        this.blackSymbol.alpha = 0;

        this.goldSymbol.position.set(72, 72);
        this.blackSymbol.position.set(72, 72);

        const posTweak = TrueGritSymbol.getSymbolPositionTweak(transformToSymbol);
        this.goldSymbol.position.x += posTweak.x;
        this.blackSymbol.position.x += posTweak.x;
        this.goldSymbol.position.y += posTweak.y;
        this.blackSymbol.position.y += posTweak.y;

        this.goldSymbol.anchor.set(0.5, 0.5);
        this.blackSymbol.anchor.set(0.5, 0.5);

        this._attentionAnimation = new TimelineSprite(TrueGrit.assetLoader.getTextures("winAnimations/winShine/winshine_"));
        this._attentionAnimation.anchor.set(0.5, 0.5);
        this._attentionAnimation.position = TrueGritSymbolTransformAnimation.WIN_SHINE_OFFSET;
        this._attentionAnimation.visible = false;

        this.graphicsContainer.addChild(this.blackSymbol, this.goldSymbol, this._attentionAnimation);

        this.addChild(this.graphicsContainer);
    }

    /*
    private createGfx(symbol:string):TransformSymbolPart {
        const container = new PIXI.Container();

        let background:PIXI.Sprite;
        let frame:PIXI.Sprite;

        let charSuffix = "";
        if(this._isLowSymbol) {
            background = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.TRANSFORM_LOW_BACKGROUND)[0]);
            frame = new PIXI.Sprite(PIXI.Texture.EMPTY);
            charSuffix = "T2";
        } else {
            background = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.TRANSFORM_MID_BACKGROUND)[0]);
            frame = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.TRANSFORM_MID_FRAME)[0]);
        }

        let character:PIXI.Sprite = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(`${symbol}/${symbol}_char${charSuffix}`)[0]);
        let characterTint:PIXI.Sprite = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(`${symbol}/${symbol}_char${charSuffix}`)[0]);
        characterTint.tint = PIXI.utils.string2hex("#000000");

        background.anchor.set(0.5, 0.5);
        frame.anchor.set(0.5, 0.5);
        character.anchor.set(0.5, 0.5);
        characterTint.anchor.set(0.5, 0.5);


        background.alpha = 0;
        frame.alpha = 0;
        character.alpha = 0;
        characterTint.alpha = 0;


        container.addChild(background, frame, character, characterTint);
        container.position.set(72, 72);

        if(symbol == "M1") {
            character.position.set(0, -4);
            characterTint.position.set(0, -4);
            container.y += 0.5;
        }
        if(symbol == "M2") {
            character.position.set(-4, -5);
            characterTint.position.set(-4, -5);
            container.x += 0.5;
            container.y += 0.0;
        }
        if(symbol == "M3") {
            character.position.set(-5.5, -7);
            characterTint.position.set(-5.5, -7);
            container.x += 0.5;
            container.y += 0.5;
        }
        if(symbol == "M4") {
            character.position.set(3.5, -1);
            characterTint.position.set(3.5, -1);
            container.x += 0;
            container.y += 1;
        }
        if(symbol == "M5") {
            character.position.set(3, 0.5);
            characterTint.position.set(3, 0.5);
            container.x += 0;
            container.y += 0;
        }

        const symbolPart:TransformSymbolPart = {
            view : container,
            background : background,
            frame : frame,
            character : character,
            characterTint : characterTint,
        }

        return symbolPart;
    }

     */

    public getRevealTransform(isBotSym:boolean = false):gsap.core.Timeline {
        if(this._isLowSymbol) {
            return this.getLowTransform(isBotSym);
        } else {
            return this.getMidTransform(isBotSym);
        }
    }

    public getAttentionAnimation(isBotSym:boolean = false):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {this._attentionAnimation.visible = true});
        if(isBotSym == true) {

        } else {
            tl.add(this._attentionAnimation.getAnimation().play().timeScale(1.6));
            tl.add(this._attentionAnimation.getAnimation().play().timeScale(1.9));
            tl.add(this._attentionAnimation.getAnimation().play().timeScale(2.0));
        }

        tl.add(() => {this._attentionAnimation.visible = false});
        return tl;
    }

    public getHide():gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(gsap.to(this.graphicsContainer, {duration : 0.2, alpha : 0}), 0.1);
        return tl;
    }

    private getLowTransform(isBotSym:boolean = false) {
        const tl:gsap.core.Timeline = gsap.timeline();
        let shine:TimelineSprite;

        if(isBotSym) {
            shine = new TimelineSprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.TRANSFORM_LOW_REVEAL), 30);
            shine.position.set(87, 82);
            shine.anchor.set(0.5, 0.5);
            this.blackSymbol.texture = TrueGrit.assetLoader.getTextures("T/T2bg")[0];
        } else {
            shine = new TimelineSprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.TRANSFORM_LOW_SHINE), 30);
            shine.position.set(72, 72);
            shine.anchor.set(0.5, 0.5);
        }

        const symbolFade:gsap.core.Timeline = gsap.timeline();

        if(isBotSym) {
            symbolFade.add(gsap.to(this.blackSymbol, {duration : 0.01, alpha : 1}));
            symbolFade.add(gsap.to(this, {duration : 0.55}));
            symbolFade.add(gsap.to(this.goldSymbol, {duration : 0.1, alpha : 1}));
            symbolFade.add(gsap.to(this.blackSymbol, {duration : 0.0001, alpha : 0}));
        } else {
            symbolFade.add(gsap.to(this, {duration : 0.2}));
            symbolFade.add(gsap.to(this.blackSymbol, {duration : 0.01, alpha : 1}));
            symbolFade.add(gsap.to(this, {duration : 0.2}));
            symbolFade.add(gsap.to(this.goldSymbol, {duration : 0.3, alpha : 1}));
            symbolFade.add(gsap.to(this.blackSymbol, {duration : 0.0001, alpha : 0}));
        }

        const shineTl:gsap.core.Timeline = gsap.timeline();
        shineTl.add(() => {this.addChild(shine)});
        shineTl.add(shine.getAnimation());
        shineTl.add(() => {this.removeChild(shine)});

        tl.add(shineTl);
        tl.add(symbolFade, 0);
        return tl;
    }

    private getMidTransform(isBotSym:boolean = false) {
        const tl:gsap.core.Timeline = gsap.timeline();
        let shine:TimelineSprite = new TimelineSprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.TRANSFORM_MID_SHINE), 30);
        shine.position.set(72, 72);
        shine.anchor.set(0.5, 0.5);

        const symbolFade:gsap.core.Timeline = gsap.timeline();
        symbolFade.add(gsap.to(this.blackSymbol, {duration : 0.1, alpha : 1}), "<");
        symbolFade.add(gsap.to(this.goldSymbol, {duration : 0.1, alpha : 1}));
        symbolFade.add(gsap.to(this.blackSymbol, {duration : 0.0001, alpha : 0}));

        const shineTl:gsap.core.Timeline = gsap.timeline();
        shineTl.add(() => {this.addChild(shine)});
        shineTl.add(shine.getAnimation());
        shineTl.add(() => {this.removeChild(shine)});

        tl.add(symbolFade);
        tl.add(shineTl, "<");
        return tl;
    }
}